import React, { useEffect, useState } from 'react';
import iconSet from '../../assets/fontIcons/selection.json';
import IcomoonReact from 'react-icomoon';

const Icon = (props) => {
  const [isFocused, setFocus] = useState(false);

  const { color = '#ccc', size = '25', icon = '', hover = color } = props;
  let styles = {
    display: 'inline-block',
    width: size + 'px',
    height: size + 'px',
  };
  useEffect(() => {}, [size]);
  return (
    <>
      <IcomoonReact
        iconSet={iconSet}
        color={isFocused ? hover : color}
        size={size}
        icon={icon}
        style={styles}
        onMouseEnter={() => setFocus(true)}
        onMouseLeave={() => setFocus(false)}
      />
    </>
  );
};

export default Icon;
